var ellipsis = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
};
export var ellipsisReset = {
  overflow: 'visible',
  whiteSpace: 'normal'
};
export default ellipsis;